import { useState } from 'react';

export default function ImageCircularAvatar({
  imageUrl,
  customClass,
  fallbackImg,
  fallbackText,
  clicked,
}: {
  imageUrl: string;
  customClass?: string;
  fallbackImg?: string;
  fallbackText?: string;
  clicked?: () => void;
}) {
  const [isImageLoadError, setIsImageLoadError] = useState(false);

  const renderFallBack = () => {
    if (fallbackImg) {
      return (
        <img
          className={`${customClass} h-10 w-10 rounded-full`}
          src={fallbackImg}
          alt='fallback-avatar'
          onClick={clicked}
        />
      );
    }

    if (fallbackText) {
      return (
        <div
          className={`${customClass} h-10 w-10 bg-gray-200 rounded-full flex justify-center items-center text-md p-2 text-primaryColor-normal font-bold tracking-wider`}
          onClick={clicked}
        >
          {fallbackText}
        </div>
      );
    }
  };

  return (
    <>
      {!isImageLoadError && imageUrl !== null && imageUrl && (
        <img
          className={`${customClass} h-10 w-10 rounded-full`}
          src={imageUrl}
          alt='avatar'
          onError={() => setIsImageLoadError(true)}
          onClick={clicked}
        />
      )}
      {(isImageLoadError || imageUrl === null || !imageUrl) && renderFallBack()}
    </>
  );
}
